import React, {  Fragment } from 'react'

const OperatorRejectedJobItem = ({ rejectedJob }) => {

    const { farm, farmer_equipment_request, status } = rejectedJob;

    const { farm_name, address } = farm;

    const { start_time, end_time } = farmer_equipment_request;


    return (
        <Fragment>
        
        <td>{farm_name}</td>
        <td>{address}</td>
        <td>{start_time}</td>
        <td>{end_time}</td>
        <td>{status === 0 ? "AVAILABLE" : status === 1 ? "ACCEPTED" : "REJECTED"}</td>


    </Fragment>
    )
}

export default OperatorRejectedJobItem
